import { Dialog, DialogTitle, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { FC } from 'react';
import { SessionStatus } from '../../interfaces/types';

export interface SimpleDialogProps {
    open: boolean;
    selectedValue: string;
    onClose: (value: string) => void;
  }

const SessionBulkEditDialog: FC<SimpleDialogProps> = ({open, selectedValue, onClose}) => {

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Select the new status</DialogTitle>
      <List sx={{ pt: 0 }}>
        {Object.values(SessionStatus).map((status) => (
          <ListItem disablePadding key={status}>
            <ListItemButton onClick={() => handleListItemClick(status)}>
              <ListItemText primary={status} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};

export default SessionBulkEditDialog;
